// extracted by mini-css-extract-plugin
export default {"tabActive":"liffTab_tabActive__ZIVIW","sortAsc":"liffTab_sortAsc__Xo+nN","sortDesc":"liffTab_sortDesc__U-vgw"};